import { IconArrow } from "./IconArrow";
import { IconBarcode } from "./IconBarcode";
import { IconBoard } from "./IconBoard";
import { IconCalendar } from "./IconCalendar";
import { IconChange } from "./IconChange";
import { IconChartPie } from "./IconChartPie";
import { IconHome } from "./IconHome";
import { IconInfo } from "./IconInfo";
import { IconLoading } from "./IconLoading";
import { IconMic } from "./IconMic";
import { IconMicOn } from "./IconMicOn";
import { IconPencil } from "./IconPencil";
import { IconPeople } from "./IconPeople";
import { IconPersonalData } from "./IconPersonalData";
import { IconStethoscope } from "./IconStethoscope";
import { IconSearch } from "./IconSearch";
import { IconClose } from "./IconClose";
import { ReactNode } from "react";
import { IconArrow400 } from "./IconArrow400";
import { IconMountains } from "./IconMountains";
import { IconAmbulance } from "./IconAmbulance";
import { IconDownload } from "./IconDownload";
import { IconPlusSquare } from "./IconPlusSquare";
import { IconDomiciliaryHealth } from "./IconDomiciliaryHealth";
import { IconCheck } from "./IconCheck";
import { IconCheckCircle } from "./IconCheckCircle";
import { IconAdd } from "./IconAdd";
import { IconDot } from "./IconDot";
import { IconDecorativeLine } from "./IconDecorativeLine";
import { IconCheckPlus } from "./IconCheckPlus";
import { IconEye } from "./IconEye";
import { IconFile } from "./IconFile";
import { IconInfoMessage } from "./IconInfoMessage";
import { IconAuditDocument } from "./IconAuditDocument";
import { IconSearchFilter } from "./IconSearchFilter";
import { IconSignaturePencil } from "./IconSignaturePencil";
import { IconTrash } from "./IconTrash";
import { IconAuditReport } from "./IconAuditReport";
import { IconEmergencias } from "./IconEmergencias";
import { IconPlus } from "./IconPlus";
import { IconShuffle } from "./IconShuffle";
import { IconAvatar } from "./IconAvatar";
import { IconPlane } from "./IconPlane";
import { IconRenaper } from "./IconRenaper";
import { IconEscudoNacional } from "./IconEscudoNacional";
import { IconPatientInfo } from "./IconPatientInfo";
import { IconCamera } from "./IconCamera";
import { IconImage } from "./IconImage";
import { IconUploadCloud } from "./IconUploadCloud";

const ICON_COMPONENTS = {
  iconAdd: IconAdd,
  iconAmbulance: IconAmbulance,
  iconArrow: IconArrow,
  iconArrow400: IconArrow400,
  iconBarcode: IconBarcode,
  iconBoard: IconBoard,
  iconCamera: IconCamera,
  iconCalendar: IconCalendar,
  iconChange: IconChange,
  iconChartPie: IconChartPie,
  iconCheck: IconCheck,
  iconCheckCircle: IconCheckCircle,
  iconCheckPlus: IconCheckPlus,
  iconClose: IconClose,
  iconDomiciliaryHealth: IconDomiciliaryHealth,
  iconDownload: IconDownload,
  iconEye: IconEye,
  iconHome: IconHome,
  iconInfo: IconInfo,
  iconInfoMessage: IconInfoMessage,
  iconImage: IconImage,
  iconLoading: IconLoading,
  iconMic: IconMic,
  iconMicOn: IconMicOn,
  iconMountain: IconMountains,
  iconPeople: IconPeople,
  iconPatientInfo: IconPatientInfo,
  iconPencil: IconPencil,
  iconPersonalData: IconPersonalData,
  iconPlane: IconPlane,
  iconPlus: IconPlus,
  iconPlusSquare: IconPlusSquare,
  iconSearch: IconSearch,
  iconSignaturePencil: IconSignaturePencil,
  iconStethoscope: IconStethoscope,
  iconDot: IconDot,
  iconDecorativeLine: IconDecorativeLine,
  iconFile: IconFile,
  iconSearchFilter: IconSearchFilter,
  iconAuditDocument: IconAuditDocument,
  iconTrash: IconTrash,
  iconUploadCloud: IconUploadCloud,
  iconAuditReport: IconAuditReport,
  iconEmergencias: IconEmergencias,
  iconShuffle: IconShuffle,
  iconAvatar: IconAvatar,
  iconRenaper: IconRenaper,
  iconEscudoNacional: IconEscudoNacional,
};

export type IconComponentName = keyof typeof ICON_COMPONENTS;

export type IconProps = {
  name?: IconComponentName;
  width?: number;
  height?: number;
  isHovered?: boolean;
  children?: ReactNode;
  color?: string;
  variant?: "stroke" | "fill";
  status?: "success" | "error";
};

export const Icons = ({
  name,
  width,
  height,
  isHovered,
  color,
  variant,
  status,
}: IconProps) => {
  if (!name) {
    return null;
  }
  const SvgComponent = ICON_COMPONENTS[name];

  return (
    <SvgComponent
      width={width}
      height={height}
      isHovered={isHovered}
      color={color}
      variant={variant}
      status={status}
    />
  );
};
